// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const resetNewTransfer = overrideAccountUpdation => ({
    overrideAccount: overrideAccountUpdation,
    type: actions.UPDATE_OVERRIDE_CLOSE_ACCOUNT
});




// WEBPACK FOOTER //
// ./src/tcsm/wip/action-creators/reset-new-transfer.js